import type { CategoryLabels } from "@ondit/ui";
import { useT } from "~/core/i18n";

/** The picker's words in the panel's table; the field's own label is the caller's. */
export function useCategoryLabels(label: string): CategoryLabels {
	const t = useT();
	return {
		label,
		placeholder: t("category.placeholder"),
		search: t("category.search"),
		empty: t("category.empty"),
		loading: t("category.loading"),
		back: t("category.back"),
		whole: (name) => t("category.whole", { name }),
		full: (max) => t("category.full", { max }),
	};
}
